import { Box, Container, Typography } from "@mui/material"

import NavbarOffset from "./NavbarOffset"

const makeStyles = () => ({
    section: {
        backgroundColor: "#F4F6F8",
        color: "text.primary",
    },
    content: {
        pt: { xs: 3, md: 4 },
        pb: { xs: 3, md: 4 },
    },
})

const PageHeader = ({ title, subtitle }) => {
    const styles = makeStyles()

    return (
        <Box component="section" sx={styles.section}>
            <NavbarOffset />
            <Container maxWidth="lg" sx={styles.content}>
                <Typography
                    variant="h3"
                    fontWeight={800}
                    sx={{ fontSize: { xs: "2rem", md: "2.5rem" }, lineHeight: 1.15 }}
                >
                    {title}
                </Typography>
                {subtitle && (
                    <Typography
                        variant="body1"
                        mt={1.5}
                        color="text.secondary"
                        sx={{ maxWidth: 720 }}
                    >
                        {subtitle}
                    </Typography>
                )}
            </Container>
        </Box>
    )
}

export default PageHeader
